import {
  Component,
  ComponentInterface,
  Event,
  EventEmitter,
  h,
  Prop,
} from '@stencil/core';

import { InterfaceResultTimetableList } from './paf-result-timetable-list.custom';

/**
 * @slot unnamed - Slot to render paf-result-timetable-row instances.
 */

@Component({
  shadow: true,
  styleUrl: 'paf-result-timetable-list.scss',
  tag: 'paf-result-timetable-list',
})

export class PafResultTimetableList implements ComponentInterface {

  /**
   * If set, the button to show the previous connections will be displayed
   */
  @Prop() public previousButtonText?: string;

  /**
   * If set, the button to show the next connections will be displayed
   */
  @Prop() public nextButtonText?: string;

  /**
   * If set to true, the previous/next buttons are hidden
   */
  @Prop() public buttonsHidden: boolean;

  /**
   * If set to true, the previous/next buttons are disabled
   */
  @Prop() public buttonsDisabled: boolean;

  /**
   * Define visibility of component. This supports in animating the component.
   * e.g. set visiblity to false in init. Then, during render, set it to true
   * will leed to a soft fade-in.
   */
  @Prop() public visible? = true;

  /**
   * Event which will be emitted if previous or next button is clicked.
   * The payload detail contains a string if event was triggered by
   * previous or next button.
   */
  @Event({
    bubbles: true,
    composed: true,
    eventName: 'paf-result-timetable-list_prev-next-clicked',
  })
  public prevNextClicked: EventEmitter<InterfaceResultTimetableList['previousOrNextConnections']>;

  public render(): HTMLDivElement {
    return (
      <div class={{
        'result-list-wrapper': true,
        'visible': this.visible,
      }}>

        {(this.previousButtonText && !this.buttonsHidden) &&
          <paf-button
            class='button'
            disabled={this.buttonsDisabled}
            text={this.previousButtonText}
            variant='secondary'
            data-testid='button-previous'
            onClick={() => {
              this.prevNextClicked.emit('previous');
            }}
          />
        }

        <div class='result-list'>
          <slot />
        </div>

        {(this.nextButtonText && !this.buttonsHidden) &&
          <paf-button
            class='button'
            disabled={this.buttonsDisabled}
            text={this.nextButtonText}
            variant='secondary'
            data-testid='button-next'
            onClick={() => {
              this.prevNextClicked.emit('next');
            }}
          />
        }
      </div>
    );
  }
}
